import { Component, OnInit, ChangeDetectionStrategy, ViewChild, OnDestroy } from '@angular/core';
import { AlertsComponent } from '../../../pillar/alerts/components/alerts.component';
import { StoreDataSource } from '../../../core/services/StoreDataSource';
import { DataSetRootEntityModel } from '../../models/DataSetRootEntityModel';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import { ModuleConfiguration } from '../../datawarehouse.module.config';
import * as fromStore from '../../store/reducers';
import * as dashboardActions from '../../../pillar/dashboard/store/actions';
import { DataWarehouseEntityListComponent } from '../data-warehouse-entity-list/data-warehouse-entity-list.component';
import { DataWarehouseContextManagerService } from '../../service/data-warehouse-context-manager.service';
import { DataWarehouseService } from '../../../core/services';

@Component({
  selector: 'brd-data-warehouse-dashboard',
  templateUrl: './data-warehouse-dashboard.component.html',
  styleUrls: ['./data-warehouse-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataWarehouseDashboardComponent implements OnInit, OnDestroy {
  displayedColumns = [ 'dataEntityDisplayName' ];
  dataSource$: Observable<DataSetRootEntityModel[]>;
  loading:boolean;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  selectedEntity: DataSetRootEntityModel = undefined;
  private _selectedItemKey = 'DataWarehouseDashboardComponent_SelectedItem';

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  @ViewChild(DataWarehouseEntityListComponent)
  list: DataWarehouseEntityListComponent;

  constructor(private store: Store<any>, 
    public _dataWarehouseContextManager: DataWarehouseContextManagerService,
    private _dataWarehouseServer: DataWarehouseService) { }

  ngOnInit() {
    this.loading = false;

    this._dataWarehouseContextManager.selectedSubmittingEntity$
    .takeUntil(this.destroyed$)
    .subscribe( s => {
      if(s){
        this.loading = true;
        this.dataSource$ = this._dataWarehouseServer.getSubmittingEntityAllowedRootEntities(s.key).map( r => {
          this.loading = false;
          if(this.selectedEntity){
            this.selectItem(r.model.find( r => r.dataSetKey === this.selectedEntity.dataSetKey));
          }
          return r.model;
        });
      } else {
        this.dataSource$ = null;
        this.loading = false;
      }
    });

    var selectedItemJson = sessionStorage.getItem(this._selectedItemKey);
    if(selectedItemJson){
      this.selectItem(JSON.parse(selectedItemJson));
    }
  }

  ngOnDestroy () {
    this.destroyed$.next(true);
  }

  selectItem (item: DataSetRootEntityModel) {
    this.selectedEntity = item;
    if(this.selectedEntity){
    sessionStorage.setItem(this._selectedItemKey,JSON.stringify(this.selectedEntity));
    } else {
      sessionStorage.removeItem(this._selectedItemKey);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/components/data-warehouse-dashboard/data-warehouse-dashboard.component.ts